<div *ngIf="randType">
  <img src="/assets/congratsIll.svg" alt="" class="w-100 mb-9">
  <h2 class="text-center px-5 mb-10">
    Thank you for the tips🥰
  </h2>
</div>
<div *ngIf="!randType">
  <h2 class="text-center px-7 mt-10">
    Thank you for the tips🥰
  </h2>
  <img src="/assets/hands.svg" alt="" class="w-100 mb-12">
  <div class="row justify-content-center">
    <div class="col-10 mb-10">
      <button
        type="button"
        (click)="close()"
        class="btn btn-outline border-2 app-btn-yellow w-100">
        You're welcome
      </button>
    </div>
  </div>
</div>
